<template>
    <!--<div class="row">
        <div class="col-12">
            <div class="listy b-b">
                <div class="label">
                    {{ t.betting.title.status }}
                </div>
                <template v-if="bet.result.key == 'waiting'">
                    <span class="status-pill yellow smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
                </template>
                <template v-if="bet.result.key == 'win' || bet.result.key == 'refund'">
                    <span class="status-pill green smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
                </template>
                <template v-if="bet.result.key == 'loss'">
                    <span class="status-pill red smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
                </template>
                <template v-if="bet.result.key == 'cancelled'">
                    <span class="status-pill blue smaller"></span><span>{{ t.betting[bet.result.key] }}</span>
                </template>
            </div>
        </div>
        <div class="col-6">
            <div class="listy b-b">
                <div class="label">{{ t.betting.title.amount_per_bet }}</div>
                {{ bet.amount_per_bet | toMoney(bet.currency) }}
            </div>
        </div>
        <div class="col-6">
            <div class="listy b-b">
                <div class="label">
                    {{ t.betting.title.payed }}
                </div>
                {{ bet.amount | toMoney(bet.currency) }}
            </div>
        </div>

        <div class="col-6">
            <div class="listy b-b">
                <div class="label">
                    {{ t.betting.title.bet_type }}
                </div>
                <span class="text-success">
						{{ t.betting.type[bet.type.name] }}
						<span v-if="bet.type.name == 'system'">
							({{ bet.combinations }})
						</span>
					</span>
            </div>
        </div>

        <div class="col-6">
            <div class="listy b-b">
                <div class="label">
                    {{ t.betting.title.earnings }}
                </div>
                {{ bet.earnings | toMoney(bet.currency) }}
            </div>
        </div>

        <div class="col-6">
            <div class="listy b-b">
                <div class="label">
                    {{ t.betting.title.bet_count }}
                </div>
                {{ bet.bet_count }}
            </div>
        </div>
        <div class="col-6">
            <div class="listy b-b">
                <div class="label">
                    {{ t.betting.title.odd_count }}
                </div>
                {{ bet.odd_count }}
            </div>
        </div>


        <div class="element-wrapper">
            <h6 class="element-header">{{ t.navigation.bets }}</h6>
            <div class="element-content">
                <div class="pipeline white" v-for="item in items" :class="betClass(item.oddResult)">
                    <div class="pipeline-body">
                        <div class="row">
                            <div class="col-12">
                                <scoreboard collapseTo="scoreboard" layout="mini" :matchId.sync="item.statsId"/>
                            </div>
                            <div class="col-12">
                                <div class="listy b-b">
									<span class="label">
										{{ t.betting.title.status }}
									</span>
                                    <template v-if="item.oddResult == 'waiting'">
                                        <span class="status-pill yellow smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
                                    </template>
                                    <template v-if="item.oddResult == 'win' || item.oddResult == 'refund'">
                                        <span class="status-pill green smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
                                    </template>
                                    <template v-if="item.oddResult == 'loss'">
                                        <span class="status-pill red smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
                                    </template>
                                    <template v-if="item.oddResult == 'cancelled'">
                                        <span class="status-pill blue smaller"></span><span>{{ t.betting[item.oddResult] }}</span>
                                    </template>
                                </div>
                            </div>
                            <div class="col-12" v-if="!item.statsId">
                                <table class="table table-compact smaller b-b" v-if="items">
                                    <thead>
                                    <tr>
                                        <th>{{item.sportName}} > {{ item.regionName }} > {{ item.competitionName }}</th>
                                        <th class="text-center">HT</th>
                                        <th class="text-center">FT</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>
                                            <img width="20" height="20" class="pull-left mr-2"
                                                 :src="'https://ls.sportradar.com/ls/crest/medium/'+item.fcExtendedId+'.png'"/>
                                            {{ item.fcName | slimiter(20) }}
                                        </td>
                                        <td class="text-center w50">
											<span v-if="mData(item.mData).hasOwnProperty('score_ht')">
												{{ mData(item.mData).score_ht.home }}
											</span>
                                        </td>
                                        <td class="text-center w50">
											<span v-if="mData(item.mData).hasOwnProperty('score')">
												{{ mData(item.mData).score.home }}
											</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <img width="20" height="20" class="pull-left mr-2"
                                                 :src="'https://ls.sportradar.com/ls/crest/medium/'+item.scExtendedId+'.png'"/>
                                            {{ item.scName | slimiter(20) }}
                                        </td>
                                        <td class="text-center w50">
											<span v-if="mData(item.mData).hasOwnProperty('score_ht')">
												{{ mData(item.mData).score_ht.away }}
											</span>
                                        </td>
                                        <td class="text-center w50">
											<span v-if="mData(item.mData).hasOwnProperty('score')">
												{{ mData(item.mData).score.away }}
											</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-12" v-if="item.isLive">
                                <div class="listy b-b">
									<span class="label">
										{{ t.time_period }}
									</span>
                                    {{ item.betResult }}
                                    <span class="pull-right" v-if="item.hasOwnProperty('periodTime')">
										<i class="icon-clock"></i> {{ periodTimer(item) }}
									</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="listy b-b">
									<span class="label">
										{{ item.name }}
										<span v-if="item.specialValue">
											{{ item.specialValue  }}
										</span>
									</span>
                                    {{ item.selection }}
                                    <span class="text-success pull-right">{{ item.oddValue }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>-->

  <div class="MyBetsListItemDesktop-styles-bet-content">
    <div class="Animation-styles-elements">
      <ul class="MyBetsListItemDesktop-styles-bet-list">
        <li class="MyBetsBetItem-styles-bet MyBetsBetItem-styles-desktop" v-for="item in items">
          <div class="MyBetsBetItem-styles-bet-layout">
            <div class="MyBetsBetItem-styles-bet-market"><span class="">{{ item.name }}: </span>
              <span class="MyBetsBetItem-styles-bet-placed">{{ item.selection }}</span></div>
            <div class="MyBetsBetItem-styles-bet-teams">{{ item.fcName | slimiter(20) }} - {{ item.scName | slimiter(20) }}</div>
            <div class="MyBetsBetItem-styles-bet-details">
              <span v-if="!item.matchOnLive" class="MyBetsBetItem-styles-datetime">
                {{ item.matchStartDate | moment('D.M, HH:mm', session.timezone)}}
              </span>
              <span v-if="item.matchOnLive" class="MyBetsBetItem-styles-datetime">
                  {{ item.matchResultName }}
              </span>
              <span v-if="item.matchOnLive" class="MyBetsBetItem-styles-datetime">
                  {{ periodTimer({periodTimeLeft: 0, periodTime: item.matchPeriodTime}) }}
              </span>
              <span class="MyBetsBetItem-styles-bet-result" v-if="item.mData.hasOwnProperty('score')">
                    {{item.mData.score.home}} - {{item.mData.score.away}}
                  <span v-if="item.matchStats.hasOwnProperty('1st half')">
                    ( {{item.matchStats['1st half'].score.home}} - {{item.matchStats['1st half'].score.away}} )
                  </span>
              </span>

              <span class="MyBetsBetItem-styles-bet-result" v-if="item.betData">
                    {{ t.bet_place_time }}: {{item.betData.score.home}} - {{item.betData.score.away}}
              </span>
            </div>
          </div>
          <div v-if="item.oddResultId == 1 && item.oddResultId >= 1" class="MyBetsBetItem-styles-bet-quote MyBetsBetItem-styles-aligned">{{ item.oddValue}}</div>
          <template v-if="item.oddResultId > 1">
                <template v-if="item.oddResultId <= 3">
                <div :class="(item.oddResult === 'win') ? 'MyBetsBetItem-styles-won' : 'MyBetsBetItem-styles-lost'" class="MyBetsBetItem-styles-bet-quote MyBetsBetItem-styles-aligned">{{ item.oddValue }}</div>
            </template>
            <template v-if="item.oddResultId > 3">
                <div :class="(item.oddResult === 'win') ? 'MyBetsBetItem-styles-won' : 'MyBetsBetItem-styles-lost'" class="MyBetsBetItem-styles-bet-quote MyBetsBetItem-styles-aligned">{{ item.oddValue }}</div>
            </template>
          </template>
          
        </li>
      </ul>
      <div class="MyBetsListItemDesktop-styles-bet-item-footer">
        <div class="MyBetsListItemDesktop-styles-bet-item-info">Betslip ID: <span>{{ bet.id }}</span></div>
        <div class="MyBetsListItemDesktop-styles-bet-item-action-buttons"></div>
      </div>
    </div>
  </div>
</template>

<script>
    import PeriodTime from '../registration.vue'
    import scoreboard from '@/components/sportsbook/widget/scoreboard'

    export default {
        name: 'betDetail',
        components: {scoreboard, PeriodTime},
        props: {
            betid: {
                default: 0,
                type: Number
            }
        },
        data() {
            return {
                session: this.$root.session,
                t: this.$root.t,
                items: [],
                bet: [],
                notfound: false
            }
        },
        mounted() {
            this.fetchBets();
        },
        watch: {
            'betid'() {
                this.fetchBets();
            }
        },
        methods: {
            onChangePage(page) {
                this.pagination.current = page;
                this.filter.page = page;
                this.$router.push({query: {}});
                this.$router.push({query: {page: page}});

                window.scroll(0, 0);
            },
            async fetchBets() {

                this.$http.get(bsapi + 'api/v1/bet/detail/' + this.betid)
                    .then(response => {

                        this.bet = response.body.result.bet;
                        this.items = response.body.result.items;
                    }, response => {
                        this.notfound = 1;
                    })
            },
            betClass(result) {
                if (result == 'waiting') {
                    return 'lined-warning';
                }
                if (result == 'cancelled') {
                    return 'lined-primary';
                }
                if (result == 'win' || result == 'refund') {
                    return 'lined-success';
                }
                if (result == 'loss') {
                    return 'lined-danger';
                }
            },
            mData(data) {
                return data;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .nav-link span {
        display: inline-block;
    }

    .team-repeat {
        width: 120px;
        text-align: left;
    }

    .team-repeat img {
        margin-right: 5px;
    }

    .amount-b {
        min-width: 30%;
        float: right;
    }

    .event-row {
        border-bottom: 1px solid #ccc;
        display: flex;
    }

    .sheet-c2.mcol {
        width: 17.5%!important;
    }

    .sheet-c3.mcol {
        width: 37.5%!important;
    }

    .sheet-c5.mcol {
        width: 10%!important;
    }

    .sheet-c6.mcol {
        text-align: right!important;
        padding-right: 3px;
    }

    .event-row:last-child {
        border-bottom: none;
    }

    .event-row.loss {
        border-left: 3px solid red;
    }
    .event-row.win {
        border-left: 3px solid green;
    }
    .event-row.cancelled {
        border-left: 3px solid grey;
    }
    .event-row.wait {
        border-left: 3px solid darkblue;
    }
    .scoreColor.loss{
        color: red;
    }
    .scoreColor.win{
        color: green;
    }
    .scoreColor.cancelled{
        color: grey;
    }
    .scoreColor.wait{
        color: darkblue;
    }
</style>



// WEBPACK FOOTER //
// src/components/user/account/betDetail.vue